import { Table } from '@startuptools/ui/Table';
import { Typography } from '@startuptools/ui/Typography';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { Trans } from '@lingui/react';
import React from 'react';

export const EmptyState = ({ cta, header }: { cta: React.ReactNode; header: React.ReactNode }) => {
  return (
    <Stack gap={2} p={2}>
      <Typography level="body-sm">{header}</Typography>
      <Stack direction="row" justifyContent="center">
        {cta}
      </Stack>
    </Stack>
  );
};
export const DashboardTable = ({
  hasItems,
  title,
  emptyState,
  filter,
  rows,
  hoverRow = true,
  dateLabel = <Trans id="Date" />,
}: {
  title: React.ReactNode;
  emptyState: React.ReactNode;
  rows: React.ReactNode;
  dateLabel?: React.ReactNode;
  hasItems: boolean;
  filter?: React.ReactNode;
  hoverRow?: boolean;
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1,
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        }}
      >
        <Typography level="body-lg" sx={{ flex: '1 1 100%' }} component="div">
          {title}
        </Typography>

        {hasItems && filter}
      </Box>
      {!hasItems && emptyState}
      {hasItems && (
        <Table
          hoverRow={hoverRow}
          sx={{
            '& tr': hoverRow ? { cursor: 'pointer' } : {},
            '& thead th:nth-child(1)': { width: '30%' },
            '& thead th:nth-child(2)': { width: '15%' },
          }}
        >
          <thead>
            <tr>
              <th>
                <Trans id="Name" />
              </th>
              <th>{dateLabel}</th>
              <th>
                <Trans id="Status" />
              </th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      )}
    </>
  );
};
